import { Alert, Box, Button, CircularProgress, Paper, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminTotpVerify } from '../../api/adminApi';
import { useAdminAuth } from '../../Context/AdminAuthContext';

export default function AdminTotpVerify() {
    const { preAuthToken, loginAdmin } = useAdminAuth();
    const navigate = useNavigate();
    const [code, setCode] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!preAuthToken) { navigate('/admin/login'); return; }
        setError('');
        setLoading(true);
        try {
            const result = await adminTotpVerify(preAuthToken, code);
            loginAdmin(result.token);
            navigate('/admin');
        } catch {
            setError('Invalid code — try again');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f5f5f5' }}>
            <Paper sx={{ p: 4, width: 360 }} elevation={3}>
                <Typography variant="h5" fontWeight={700} mb={1}>Two-factor authentication</Typography>
                <Typography color="text.secondary" variant="body2" mb={3}>
                    Enter the 6-digit code from Google Authenticator, or a backup code.
                </Typography>

                {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

                <Box component="form" onSubmit={handleSubmit}>
                    <TextField
                        label="Verification code"
                        fullWidth
                        required
                        autoFocus
                        value={code}
                        onChange={e => setCode(e.target.value)}
                        inputProps={{ maxLength: 10, inputMode: 'numeric' }}
                        sx={{ mb: 3 }}
                    />
                    <Button type="submit" variant="contained" fullWidth size="large" disabled={loading}>
                        {loading ? <CircularProgress size={22} /> : 'Verify'}
                    </Button>
                    <Button fullWidth sx={{ mt: 1 }} onClick={() => navigate('/admin/login')}>
                        Back
                    </Button>
                </Box>
            </Paper>
        </Box>
    );
}
